import { _ } from '../utils.js'
import * as d3 from 'd3-3'
import Datamap from 'datamaps'
import Tooltip from './tooltip.js'
import TriggerTooltip from './trigger-tooltip.js'
import tippy from 'tippy.js'

const areas = {
    'EMEA': [
        'AFG', 'ALA', 'ALB', 'DZA', 'AND', 'AGO', 'ARM', 'AUT', 'AZE', 'BHR',
        'BLR', 'BEL', 'BEN', 'BIH', 'BWA', 'BVT', 'BGR', 'BFA', 'BDI', 'CMR',
        'CPV', 'CAF', 'TCD', 'COM', 'COD', 'COG', 'CIV', 'HRV', 'CYP', 'CZE',
        'DNK', 'DJI', 'EGY', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FIN',
        'FRA', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GGY',
        'GIN', 'GNB', 'VAT', 'HUN', 'ISL', 'IRN', 'IMN', 'ISR', 'ITA', 'JEY',
        'JOR', 'KAZ', 'KEN', 'KWT', 'KGZ', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY',
        'LIE', 'LTU', 'LUX', 'MKD', 'MDG', 'MWI', 'MLI', 'MLT', 'MRT', 'MUS',
        'MYT', 'MDA', 'MCO', 'MNE', 'MAR', 'MOZ', 'NAM', 'NLD', 'NER', 'NGA',
        'NOR', 'OMN', 'PSE', 'POL', 'PRT', 'QAT', 'REU', 'ROU', 'RUS', 'RWA',
        'SHN', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SVK', 'SVN',
        'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'SDN', 'SJM', 'SWE', 'CHE', 'SYR',
        'TJK', 'TZA', 'TGO', 'TUN', 'TUR', 'UGA', 'UKR', 'ARE', 'ESH', 'YEM',
        'ZMB', 'ZWE',
    ],
    'Americas': [
        'AIA', 'ATG', 'ARG', 'ABW', 'BHS', 'BRB', 'BLZ', 'BMU', 'BOL', 'BES',
        'BRA', 'CAN', 'CYM', 'CHL', 'COL', 'CRI', 'CUB', 'CUW', 'DMA', 'DOM',
        'ECU', 'SLV', 'GUF', 'GRD', 'GLP', 'GTM', 'GUY', 'HTI', 'HND', 'JAM',
        'MTQ', 'MEX', 'MSR', 'NIC', 'PAN', 'PRY', 'PER', 'PRI', 'BLM', 'KNA',
        'LCA', 'MAF', 'SPM', 'VCT', 'SXM', 'SUR', 'TTO', 'TCA', 'USA', 'URY',
        'VEN', 'VGB', 'VIR',
    ],
    'Asia Pacific': [
        'ASM', 'ATA', 'AUS', 'BGD', 'BTN', 'IOT', 'BRN', 'KHM', 'CHN', 'CXR',
        'CCK', 'COK', 'FJI', 'PYF', 'ATF', 'GUM', 'HMD', 'HKG', 'IND', 'IDN',
        'JPN', 'KIR', 'PRK', 'KOR', 'LAO', 'MAC', 'MYS', 'MDV', 'MHL', 'FSM',
        'MNG', 'MMR', 'NRU', 'NPL', 'NCL', 'NZL', 'NIU', 'NFK', 'MNP', 'PAK',
        'PLW', 'PNG', 'PHL', 'PCN', 'WSM', 'SGP', 'SLB', 'LKA', 'TWN', 'THA',
        'TLS', 'TKL', 'TON', 'TKM', 'TUV', 'UMI', 'UZB', 'VUT', 'VNM', 'WLF',
    ],
    'UK & Ireland': [
        'GBR', 'IRE',
    ],
}

export default class LocationMaps {
    constructor(el) {
        this.el = el
        this.locations = JSON.parse(this.el.dataset.locations || '[]')
        this.buttonsContainer = this.el.querySelector('[data-region-buttons]')
        this.contentEl = this.el.querySelector('[data-region-content]')
        this.init()
    }

    init() {
        this.renderButtons()
        this.buttons = this.el.querySelectorAll('[data-region-buttons] .region-btn')

        this.buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                this.setActiveRegion(btn.dataset.regionId)
            })
        })

        if (this.locations.length > 0) {
            this.renderAllRegions()
            this.renderDropdown()

        }

        this.initMap()
    }

    initMap() {
        this.map = new Datamap({
            element: document.getElementById('map'),
            projection: 'equirectangular',
            responsive: true,
            fills: {
                defaultFill: 'url(#dot-pattern)',
                defaultFillColor: 'green',
                activeFill: 'rgb(193, 26, 133)',
            },
            geographyConfig: {
                highlightFillColor: 'url(#dot-pattern)',
                borderColor: 'transparent',
                borderWidth: 0.5,
                highlightBorderWidth: 1,
                highlightBorderColor: 'rgb(193, 26, 133)',
                highlightOnHover: false,
                popupOnHover: false,
                popupTemplate: (geo, data) => {
                    const countryName = geo.properties.name || 'Unknown';
                    const countryCount = this.findCountryByName(countryName).locations.length;
                    if (countryCount < 2) {
                        return '';
                    }
                    return ['<div class="tag tooltip__tag">',
                        countryName + ': ' + countryCount,
                        '</div>'].join('');
                }

            },
            done: (datamap) => {
                this.datamap = datamap
                d3.select(window).on('resize', () => datamap.resize())

                const svg = d3.select(datamap.options.element).select('svg')


                const defs = svg.append("defs")
                defs.append("pattern")
                    .attr("id", "dot-pattern")
                    .attr("x", 0)
                    .attr("y", 0)
                    .attr("width", 5)
                    .attr("height", 5)
                    .attr("patternUnits", "userSpaceOnUse")
                    .append("circle")
                    .attr("cx", 2.5)
                    .attr("cy", 2.5)
                    .attr("r", 2)
                    .attr("fill", "#B5B5B5")

                defs.append("pattern")
                    .attr("id", "active-pattern")
                    .attr("x", 0)
                    .attr("y", 0)
                    .attr("width", 5)
                    .attr("height", 5)
                    .attr("patternUnits", "userSpaceOnUse")
                    .append("circle")
                    .attr("cx", 2.5)
                    .attr("cy", 2.5)
                    .attr("r", 2)
                    .attr("fill", "#2b7c8a")

                svg.selectAll(".datamaps-subunit")
                    .attr("fill", "url(#dot-pattern)")

                this.locations.forEach(region => {
                    region.countries.forEach(country => {
                        const locationCount = country.locations.length
                        let lat
                        let lng

                        const markerGroup = datamap.svg.append('g')
                            .attr('class', 'location-marker')
                            .attr('data-region-id', region.id)
                            .style('cursor', 'pointer')

                        if (country.grouped) {
                            lat = parseFloat(country.lat)
                            lng = parseFloat(country.lng)
                            const coords = datamap.projection([lng, lat])
                            if (!coords.includes(NaN)) {
                                this.renderCircle({ markerGroup, coords, locationCount, radius: 5, region, locationId: country.id })
                            }

                        } else {
                            country.locations.forEach(loc => {
                                lat = parseFloat(loc.lat)
                                lng = parseFloat(loc.lng)
                                const coords = datamap.projection([lng, lat])
                                if (!coords.includes(NaN)) {
                                    this.renderCircle({markerGroup, coords, locationCount: 0, radius: 5, region, locationId: country.id})
                                }
                            });
                        }
                    })
                })

                _('tippy').nodes().forEach((el) => new Tooltip(el))
                _('trigger-tippy').nodes().forEach((el) => new TriggerTooltip(el))


                if (this.activeRegion) {
                    this.highlightMarkers(this.activeRegion.id)
                }

                datamap.resize()
            },
        })
    }

    renderAllRegions() {
        this.contentEl.innerHTML = `
            ${this.locations.map(region => `
                <h2 class="office-block__heading">${region.heading}</h2>
                ${this.officeBlockRender(region)}
            `).join('')}
        `
    }

    officeBlockRender(region) {
        return region.countries.map(country => `
            ${country.displayCountryName ? `<h3 class="heading--3 office-block__country-heading">${country.country}</h3>` : ''}
            <div class='office-block'>
                ${country.locations.map(loc => `
                    <div class='office'>
                        ${loc.image ? (loc.image.includes('<picture') ? loc.image : `<img src='${loc.image}' alt='${loc.city || country.country} office'>`) : ''}
                        ${loc.name ? `<h3 class="heading--4 u-mb-8">${loc.name}</h3>` : ''}
                        ${loc.city ? `<p class="copy--small"><strong>${loc.city}</strong></p>` : ''}
                        ${loc.address ? `<p class="copy--small">${loc.address.replace(/\n/g, '<br>')}</p>` : ''}
                        ${(() => {
                            if (loc.linkType === 5 && loc.linkTel) {
                                return `<a class='button' href="tel:${loc.linkTel}">${loc.linkText || 'Contact'}</a>`
                            } 
                            if (loc.linkType === 6 && loc.linkMailTo) {
                                return `<a class='button' href="mailto:${loc.linkMailTo}">${loc.linkText || 'Contact'}</a>`
                            } 
                            if (loc.link && loc.link.url && this.isValidUrl(loc.link.url)) {
                                return `<a class='button' href="${loc.link.url}" target="${loc.link.target || '_self'}">
                                            ${loc.link.text || 'Contact'}
                                        </a>`
                            }
                            return ``
                        })()}
                    </div>
                `).join('')}
            </div>
        `).join('')
    }

    renderCircle({ markerGroup, coords, locationCount, radius, region, locationId }) {
        if (window.innerWidth < 480) {
            radius = 3;
        }

        markerGroup.append('circle')
            .attr('cx', coords[0])
            .attr('cy', coords[1])
            .attr('r', radius)
            .attr('fill', '#c11a85')
            .attr('stroke', 'white')
            .attr('stroke-width', 2)
            .attr('data-behaviour', 'tippy')
            .attr('data-target', 'tt-'  + region.id + '-' + locationId)
            .each(function() {
                // Attach Tippy.js tooltip to this circle
                if (locationCount < 2) {
                    return;
                }

                const country = region.countries.find(country => country.id === locationId) || 'Unknown'
                tippy(this, {
                    content: `${country.country}: ${locationCount} offices`,
                    placement: 'top',
                    arrow: true,
                    theme: 'map',
                    appendTo: () => document.body,
                    offset: [0, 8],
                })
            })

        markerGroup
            .on('click', () => {
                this.setActiveRegionByMark({ regionId: region.id, locationId });
                this.highlightMarkers(region.id)
            })
    }

    setActiveRegionByMark({ regionId, locationId }) {
        const regionData = this.locations.find(r => r.id === regionId);
        const countryData = regionData.countries.filter(c => c.id === locationId);
        const data = {
            ...regionData,
            countries: countryData.length ? countryData : regionData.countries
        }

        this.activeRegion = data;
        this.buttons.forEach(b => b.classList.remove('active'))

        const activeBtn = [...this.buttons].find(b => b.dataset.regionId === regionId)
        if (activeBtn) {
            activeBtn.classList.add('active')
        }
        this.renderRegion(data)
        this.renderDropdown(data)
    }

    renderButtons() {
        this.buttonsContainer.innerHTML = this.locations.map(region => `
            <button class='region-btn' data-region-id='${region.id}'>
                ${region.heading}
            </button>
        `).join('')
    }

    setActiveRegion(regionId) {
        const regionData = this.locations.find(r => r.id === regionId)
        this.activeRegion = regionData

        this.buttons.forEach(b => b.classList.remove('active'))
        const activeBtn = [...this.buttons].find(b => b.dataset.regionId === regionId)
        if (activeBtn) {
            activeBtn.classList.add('active')
        }

        this.renderRegion(regionData)
        this.renderDropdown(regionData)
        this.highlightMarkers(regionId)
    }

    renderRegion(region) {
        if (!region) {
            this.contentEl.innerHTML = '<p>No data</p>'
            return
        }

        this.contentEl.innerHTML = `
            <h2>${region.heading}</h2>
            ${this.officeBlockRender(region)}
        `
    }

    isValidUrl(url) {
        try {
            new URL(url)
            return true
        } catch (_) {
            return false
        }
    }

    highlightMarkers(regionId) {
        if (!this.datamap) {
            return
        }
        //Cheat code to clear selected countries
        this.datamap.updateChoropleth({ USA: 'url(#dot-pattern)' }, { reset: true })

        this.datamap.svg.selectAll('.location-marker circle')
            .transition().duration(200)
            .attr('fill', function() {
                const markerRegionId = d3.select(this.parentNode).attr('data-region-id')
                return markerRegionId === regionId ? '#2C7F93' : '#c11a85'
        })

        const regionKey = this.locations.find(r => r.id === regionId)
        const countriesInRegion = areas[regionKey.heading] || []
        countriesInRegion.forEach(countryCode => {
            this.datamap.updateChoropleth({ [countryCode]: 'url(#active-pattern)' }, { reset: false })
        })
    }

    renderDropdown(region) {
        const dropdownContainer = this.el.querySelector('[data-region-dropdown]')
        if (!dropdownContainer) {
            return
        }

        dropdownContainer.innerHTML = `
            <div class='dropdown-wrapper'>
                <select class='region-select'>
                    <option value='' disabled ${!region ? 'selected' : ''} hidden>
                        Select region
                    </option>
                    ${this.locations.map(r => `
                        <option value='${r.id}' ${region && r.id === region.id ? 'selected' : ''}>
                            ${r.heading}
                        </option>
                    `).join('')}
                </select>
                <svg width='10' height='14' class='nav__chevron nav__chevron--back'>
                    <use xlink:href='/application/themes/rawnet/app/images/sprite.svg#chevron-down'></use>
                </svg>
            </div>
        `

        const selectEl = dropdownContainer.querySelector('.region-select')
        const iconEl = dropdownContainer.querySelector('svg.nav__chevron')

        selectEl.addEventListener('change', (e) => {
            this.setActiveRegion(e.target.value)
            iconEl.classList.remove('active')
        })

        selectEl.addEventListener('focus', () => {
            iconEl.classList.add('active')
        })

        selectEl.addEventListener('blur', () => {
            iconEl.classList.remove('active')
        })

        selectEl.addEventListener('input', () => {
            iconEl.classList.remove('active')
        })
    }

    findCountryByName(name) {
        const region = this.locations.find(region =>
            region.countries.find(country => country.country === name)
        ) || 'Unknown'

        const country = region.countries.find(country => country.country === name) || 'Unknown'

        return country
    }
}
